import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../src/assets/css/style.css'
import '../src/assets/css/custom.css'
import '../src/assets/icons/Iconsmind__Ultimate_Pack/Lineicons/lineicons.css';
import '../src/assets/icons/fontawesome/css/fontawesome-all.min.css';

import { BrowserRouter } from 'react-router-dom';


import 'bootstrap/dist/js/bootstrap.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
